var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticClass: "nav-logo",
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    staticClass: "nav-logo-image",
    attrs: {
      "src": require("@/assets/logo.png"),
      "alt": "brand-logo"
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "nav-toggler",
    on: {
      "click": function click($event) {
        _vm.toggle = !_vm.toggle;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])], 1), _c('div', {
    staticClass: "mobile-menu pt-4 pb-4"
  }, [_c('ul', {
    class: "mobile-menu-links ".concat(_vm.toggle ? 'show' : 'hide')
  }, [_c('a', {
    staticClass: "mobile-menu-links-link",
    attrs: {
      "id": "home-link",
      "href": "https://routeline.com/pages/membership-overview",
      "exact": "",
      "active-class": "mobile-active",
      "tag": "li"
    }
  }, [_vm._v("\n            Memberships\n          ")]), _c('a', {
    staticClass: "mobile-menu-links-link",
    attrs: {
      "href": "https://routeline.com/pages/our-fleet",
      "active-class": "mobile-active",
      "tag": "li"
    }
  }, [_vm._v("\n            Vehicles\n          ")]), _c('a', {
    staticClass: "mobile-menu-links-link",
    attrs: {
      "href": "https://routeline.com/pages/reservations",
      "active-class": "mobile-active",
      "tag": "li"
    }
  }, [_vm._v("\n            Book Nightly\n          ")])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nav-menu"
  }, [_c('ul', {
    staticClass: "nav-menu-links"
  }, [_c('a', {
    staticClass: "nav-menu-links-link",
    attrs: {
      "id": "home-link",
      "href": "https://routeline.com/pages/membership-overview",
      "exact": "",
      "active-class": "nav-active",
      "tag": "li"
    }
  }, [_vm._v("\n            Memberships\n          ")]), _c('a', {
    staticClass: "nav-menu-links-link",
    attrs: {
      "href": "https://routeline.com/pages/our-fleet",
      "active-class": "nav-active",
      "tag": "li"
    }
  }, [_vm._v("\n            Vehicles\n          ")])])]);
}]

export { render, staticRenderFns }